import React, { useState } from "react";
import CiteSource from "./CiteSource";

const CiteMultipleSource = ({
  qid,
  citationString,
}: {
  qid: string;
  citationString: string;
}) => {
  const [showSources, setShowSources] = useState(false);
  const citations = citationString
    .split(",")
    .map((citation) => "[" + citation.trim() + "]");

  return (
    <>
      <span
        onClick={(e) => {
          setShowSources(!showSources);
        }}
        className="rounded-full bg-gray-400 text-gray-100 text-[8px] p-0.5 px-1 cursor-pointer align-top "
      >
        Sources
      </span>
      {showSources && (
        <span className="ml-2">
          {showSources &&
            citations.map((citation) => (
              <span className="">
                <CiteSource key={citation} qid={qid} id={citation} />
              </span>
            ))}
        </span>
      )}
    </>
  );
};

export default CiteMultipleSource;
